import React from 'react';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  className?: string;
}

const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`space-y-6 p-4 sm:p-6 md:p-8 max-w-7xl mx-auto ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveContainer; 